var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.object.address)?_c('p',{staticClass:"my-address"},[_c('a',{attrs:{"target":"_blank","href":'https://www.google.com/maps?q='+_vm.object.lat+','+_vm.object.lng}},[_c('i',{staticClass:"fas fa-location-arrow"}),_vm._v("\n    "+_vm._s(_vm._f("translate")('Your address'))+" : "+_vm._s(_vm.object.address)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c3fb89a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/CurrentAddressControl.vue
// module id = null
// module chunks = 